import { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import * as Stomp from "stompjs";
import * as SockJS from "sockjs-client";
import { DataContext } from ".";

const RightTable = () => {
  const { currencycode, basecurrency } = useContext(DataContext);
  const themeColor = "Dark";
  const theme = localStorage.getItem("theme");
  const [marketTradeRecords, setMarketTradeRecords] = useState([]);
  const [ctpdata, setCtpdata] = useState(null);
  const [ltpdata, setLtpData] = useState(null);
  const tradep = parseInt(localStorage.getItem("priceprc")) || 2;
  const tradem = parseInt(localStorage.getItem("amountprc")) || 6;
  // const [currency_code, setCurrencyCode] = useState(localStorage.getItem('buying_crypto_asset') || 'BTC');
  // const [base_currency, setBaseCurrency] = useState(localStorage.getItem('selling_crypto_asset') || 'USD');
  let buyingAsset = currencycode;
  let sellingAsset = basecurrency;
  const token = localStorage.getItem("access_token");
  const websocketRef = useRef(null);
  const webSocketEndPoint = "https://stream.paybito.com/SocketStream/ws";
  const topic = "/user/topic/stream";
  const topicForBtcUsd = "/topic/stream/BTCUSD";

  let stompClient = null;
  let reqNo = null;
  const connectWebSocket = () => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      const ws = new SockJS(webSocketEndPoint);
      stompClient = Stomp.over(ws);

      stompClient.connect(
        {},
        (frame) => {
          let topicToSubscribe = "";
          subscribe();
          websocketRef.current.socket = stompClient;
          const buyingAsset = currencycode;
          const sellingAsset = basecurrency;

          if (buyingAsset && sellingAsset) {
            if (
              buyingAsset.toLowerCase() === "btc" &&
              sellingAsset.toLowerCase() === "usd"
            ) {
              topicToSubscribe = topicForBtcUsd;
            } else {
              topicToSubscribe = topic;
            }

            stompClient.subscribe(topicToSubscribe, (sdkEvent) => {
              const message = JSON.parse(sdkEvent.body);

              // Call the subscribeMessage function if defined
              if (websocketRef.current.subscribeMessage) {
                websocketRef.current.subscribeMessage(message);
              }
              onMessageReceived(sdkEvent);
            });
          }
        },
        errorCallback
      );
    }
  };

  const errorCallback = (error) => {
    if (localStorage.getItem("access_token")) {
      setTimeout(() => {
        connectWebSocket();
      }, 5000);
    }
  };

  const sendMessage = (message) => {
    if (stompClient) {
      let sendEndpoint = "";
      if (buyingAsset && sellingAsset) {
        if (buyingAsset === "btc" && sellingAsset === "usd") {
          sendEndpoint = "/app/sendRequest/BTCUSD";
        } else {
          sendEndpoint = "/app/sendRequest";
        }
        stompClient.send(sendEndpoint, {}, JSON.stringify(message));
      }
    }
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    changeMessage(parsedMessage);
    const tradeHistorydata = parsedMessage;

    if (tradeHistorydata.e === "trade") {
      console.log("tradeHistorydata=>>>", tradeHistorydata);
      setMarketTradeRecords((prevRecords) => {
        let newRecords = [...prevRecords];

        tradeHistorydata.tH.forEach((trade) => {
          const price = parseFloat(trade.price).toFixed(parseInt(tradep));
          const quantity = parseFloat(trade.quantity).toFixed(parseInt(tradem));
          const newTrade = {
            quantity,
            price,
            timestamp: trade.timestamp,
            side: trade.side,
            newask: trade.side === "ASK",
            newbid: trade.side === "BID",
          };

          newRecords.unshift(newTrade);
        });

        // Ensure the 'newask' and 'newbid' properties are properly reset
        newRecords = newRecords.map((record, index) => ({
          ...record,
          newask: index === 0 && record.newask,
          newbid: index === 0 && record.newbid,
        }));

        // Limit array length to 100
        if (newRecords.length > 100) {
          newRecords = newRecords.slice(0, 100);
        }

        return newRecords;
      });

      setLtpData((prevLtpData) => marketTradeRecords[0]?.price || prevLtpData);
    }
  };

  const changeMessage = (obj) => {
    console.log("Received Message:", obj);
  };

  const subscribe = () => {
    if (buyingAsset && sellingAsset) {
      reqNo = Math.floor(Math.random() * 1000) + 1;
      const req = {
        method: "SUBSCRIBE",
        params: [
          `${buyingAsset}/${sellingAsset}@ticker`,
          `${buyingAsset}${sellingAsset}@depth`,
          `${buyingAsset}${sellingAsset}@trade`,
        ],
        id: reqNo,
      };
      setTimeout(() => {
        sendMessage(req);
      }, 10000);

      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  const unsubscribe = () => {
    const buyingAsset = buyingAsset;
    const sellingAsset = sellingAsset;

    if (buyingAsset && sellingAsset) {
      const req = {
        method: "UNSUBSCRIBE",
        params: [
          `${buyingAsset}/${sellingAsset}@ticker`,
          `${buyingAsset}${sellingAsset}@depth`,
          `${buyingAsset}${sellingAsset}@trade`,
        ],
        id: reqNo,
      };

      sendMessage(req);

      localStorage.setItem("isUnsubscribeOccured", "true");
    }
  };

  const disconnectWebSocket = () => {
    if (stompClient && stompClient.connected) {
      console.log("Disconnecting WebSocket...");
      stompClient.disconnect(() => {
        console.log("WebSocket Disconnected");
        websocketRef.current.socket = null; // Reset WebSocket reference
      });
    } else {
      console.warn("WebSocket is not connected, skipping disconnect.");
    }
  };

  const getTradePrice = (m) => {
    return parseFloat(m.price).toFixed(tradep);
  };

  const getTradeAmount = (m) => {
    return parseFloat(m.quantity).toFixed(tradem);
  };

  useEffect(() => {
    fetchTradeHistory();

    return () => {
      if (websocketRef.current) {
        disconnectWebSocket(); // Disconnect WebSocket when the component unmounts
      }
    };

    // const socket = io("wss://stream.paybito.com");

    // socket.on("message", (message) => {
    //   if (message !== " ") {
    //     const tradeHistorydata = JSON.parse(message);
    //     if (tradeHistorydata.e === "trade") {
    //       const newRecords = [...marketTradeRecords];

    //       tradeHistorydata.tH.forEach((trade) => {
    //         const newTrade = {
    //           quantity: parseFloat(trade.quantity).toFixed(tradem),
    //           price: parseFloat(trade.price).toFixed(tradep),
    //           timestamp: trade.timestamp,
    //           side: trade.side,
    //           newask: trade.side === "ASK" ? true : false,
    //           newbid: trade.side === "BID" ? true : false,
    //         };
    //         newRecords.unshift(newTrade);
    //       });

    //       newRecords.forEach((element) => {
    //         element.newask = false;
    //         element.newbid = false;
    //       });

    //       if (newRecords.length > 100) {
    //         setMarketTradeRecords(newRecords.slice(0, 100));
    //       } else {
    //         setMarketTradeRecords(newRecords);
    //       }

    //       if (newRecords.length > 0) {
    //         setCtpdata(newRecords[0].price);
    //       }
    //     }
    //   }
    // });

    // return () => {
    //   socket.disconnect();
    // };
  }, [currencycode]);

  const fetchTradeHistory = async () => {
    try {
      const response = await axios.get(
        `https://stream.paybito.com/SocketStream/api/tradeHistory?symbol=${currencycode}${basecurrency}&limit=50`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${token}`,
          },
        }
      );
      const result = response.data;

      setMarketTradeRecords(result);

      websocketRef.current = {
        socket: null,
        subscribeMessage: null,
      };

      connectWebSocket();

      //   tradeBookData(result);
      // setCtpdata(result[0].price);
    } catch (error) {
      console.error("Error fetching trade history:", error);
    }
  };
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", { hour12: false });
  };
  return (
    <>
      <div style={{ marginBottom: "35px" }} />
      <div
        className="table_content right_table"
        style={{ height: "750px", marginLeft: "5px" }}
      >
        <table>
          <thead>
            <tr>
              <th
                style={{
                  color: theme === "light" ? "black" : "",
                  textAlign: "start",
                }}
              >
                Time
              </th>
              <th style={{ color: theme === "light" ? "black" : "" }}>
                Amount{" "}
              </th>
              <th style={{ color: theme === "light" ? "black" : "" }}>Price</th>
            </tr>
          </thead>
          <tbody className="tour4">
            <tr
              style={{
                height: "8px",
                borderBottom: "1px solid rgb(62, 62, 62)",
              }}
            />
            {marketTradeRecords && marketTradeRecords?.length !== 0 ? (
              marketTradeRecords?.map((m, i) => (
                <tr key={i}>
                  <td
                    className={`askBidTd text-start ${
                      theme === "dark" ? "" : "ticker-light"
                    } ${m.newbid ? "bg-green-300" : ""}`}
                    style={{
                      textAlign: "left",
                      paddingLeft: "14px",
                    }}
                  >
                    {formatTime(m.timestamp)}
                  </td>
                  <td
                    className={`askBidTd text-center ${
                      theme === "dark" ? "" : "ticker-light"
                    } ${m.newask ? "bg-red-300" : ""}`}
                  >
                    {m.side === "BID" ? getTradeAmount(m) : getTradeAmount(m)}
                  </td>
                  <td
                    className={`askBidTd text-center ${
                      m.newbid ? "bg-green-300" : ""
                    }`}
                    style={{
                      color: m.side === "BID" ? "#21CB80" : "#f5475d",
                    }}
                  >
                    {getTradePrice(m)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>No Data</tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RightTable;
